import React, { useState, useEffect } from "react";
import { Col, Row, Container } from "react-bootstrap";
import PropTypes from 'prop-types';
import AmericoOfferCard from "../../Common/Cards/AmericoOfferCard";
import Button from '@material-ui/core/Button';
import ErrorHandler from '../../../Helpers/Errors/ErrorHandler';
import NoResultsFoundError from '../../../Helpers/Errors/CustomErrors/NoResultsFoundError';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../../sessionStorage';
import { getHealthClass } from '../Helpers/GetHealthClass';
import Step9Icon from '../icons/step_9.svg';
import SvgIcon from '@material-ui/core/SvgIcon';

export default function Offer(props) {

  const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
  const [loading, setLoading] = useState(true);
  const [showSlider, setShowSlider] = useState(false);
  const [monthlyRate, setMonthlyRate] = useState("0");
  const [logoUrl, setLogoUrl] = useState("");
  const [sliderMaxAmount] = useState(props.quoter.coverageAmount);

  let debounce = null;
  useEffect(() => {
    if (props.quoter.coverageAmount == null || props.quoter.healthClass == null || props.quoter.term == null) {
      return;
    }
    setLoading(true);
    let isSubscribed = true;
    if (debounce) {
      clearTimeout(debounce);
    }
    debounce = setTimeout(() => runQuote(() => isSubscribed), 1000);
    return () => {
      clearTimeout(debounce);
      isSubscribed = false;
    }
  }, [props.quoter.coverageAmount])

  const onSetAmount = () => {
    setShowSlider(false);
  }

  function runQuote() {
    setLoading(true);
    var rateA;
    fetch(`${covrServicesUrl}/api/Americo?faceAmount=${props.quoter.coverageAmount}&term=${props.quoter.term}&state=${props.basicInfo.state}&birthdate=${props.basicInfo.birthdate}&healthClass=${getHealthClass(props.quoter.healthClass)}&gender=${props.basicInfo.gender}&tobacco=${props.basicInfo.tobacco}`,
      {
        method: 'GET',
        headers: {
          'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
        }
      })
      .then(res => res.json())
      .then(data => {
        if (!data) {
          throw new NoResultsFoundError();
        }
        rateA = data.monthlyRate;
        setMonthlyRate(rateA);

        props.handleApprovedPremiumUpdate(props.quoter.premium, rateA);

        setLogoUrl(data.logoUrl);
        setLoading(false);
      }).catch((error) => {
        ErrorHandler(error, rateA);
        setLoading(false);
      });
  }

  const handleAmountChange = (value) => {
    props.onCoverageChanged(value);
    props.onFieldChange('coverageAmount', value);
  }

  return (
    <Container>
      <Row className="justify-content-center formPage">
        <Col lg={6} className='p-0'>
          <Row className="justify-content-center">
            <SvgIcon component={Step9Icon} className="headerIcon" />
          </Row>
          <h4 className="headerTitle">Congratulations!</h4>
          <h5 className="headerSubtitle">You have qualified for instant coverage. Secure your policy today.</h5>

          <Row className="quoter  pt-4">

            <div className="quoter w-100">
              <Container className="budget-based-quoter">

                <Row className="justify-content-center">
                  <AmericoOfferCard
                    logoUrl={logoUrl}
                    amount={props.quoter.coverageAmount}
                    productTitle="LoanMatch Protector"
                    productName="Americo"
                    term={props.quoter.term}
                    productDesc="This unique product's coverage amount decreases monthly and is designed to match a decreasing financial need."
                    monthlyRate={monthlyRate}
                    loading={loading}
                    onNextApply={props.onNext}
                    showSlider={showSlider}
                    onSetAmount={onSetAmount}
                    handleAmountChange={handleAmountChange}
                    sliderMaxAmount={sliderMaxAmount}
                  />
                </Row>

                {!showSlider &&
                  <Row className="justify-content-center">
                    <Button type="button" className="btn btn-link" onClick={() => { setShowSlider(!showSlider) }}>OTHER PRICE OPTIONS</Button>
                  </Row>
                }
              </Container>
            </div>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}

Offer.propTypes = {
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Americo/steps/Offer.js